import { render, staticRenderFns } from "./OptimizationInfo.vue?vue&type=template&id=e6ffdad0&scoped=true&lang=pug"
import script from "./OptimizationInfo.vue?vue&type=script&lang=js"
export * from "./OptimizationInfo.vue?vue&type=script&lang=js"
import style0 from "./OptimizationInfo.vue?vue&type=style&index=0&id=e6ffdad0&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6ffdad0",
  null
  
)

export default component.exports